import { render } from "./FrameMain.vue?vue&type=template&id=090c6dbb"
import script from "./FrameMain.vue?vue&type=script&lang=js"
export * from "./FrameMain.vue?vue&type=script&lang=js"

import "./FrameMain.vue?vue&type=style&index=0&id=090c6dbb&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__